<template>
  <div class="custom-select" :tabindex="tabindex" @blur="open = false">
    <div class="selected" :class="{ open: open }" @click="open = !open">
      {{ selectedLabel ? selectedLabel : "Select One" }}
    </div>
    <div
      class="items"
      :class="{ selectHide: !open }"
      style="max-height: 200px; overflow: auto"
    >
      <div v-for="(option, i) of options" :key="i" @click="handleClick(option)">
        {{ option.label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    default: {
      type: String,
      required: false,
      default: null,
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      selectedLabel: this.default ? this.default : "",
      selectedValue: this.default ? this.default : "",
      open: false,
    };
  },
  methods: {
    reset() {
      this.selectedLabel = "";
      this.selectedValue = "";
      this.open = false;
      this._emit();
    },
    handleClick(option) {
      this.selectedLabel = option.label;
      this.selectedValue = option.value;
      this.open = false;
      this._emit();
    },
    _emit() {
      this.$emit("input", this.selectedValue);
    },
  },
  mounted() {
    this._emit();
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  height: 38px;
  line-height: 38px;
}

.custom-select .selected {
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  color: #000000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  min-height: 38px;
}

.custom-select .selected.open {
  border: 1px solid #90cdf4;
  border-radius: 6px 6px 0px 0px;
}

.custom-select .selected:after {
  position: absolute;
  content: "";
  top: 22px;
  right: 1em;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: #fff transparent transparent transparent;
}

.custom-select .items {
  color: #000000;
  border-radius: 0px 0px 6px 6px;
  overflow: hidden;
  border-right: 1px solid #90cdf4;
  border-left: 1px solid #90cdf4;
  border-bottom: 1px solid #90cdf4;
  position: absolute;
  background-color: #ffffff;
  left: 0;
  right: 0;
  z-index: 1;
}

.custom-select .items div {
  color: #000000;
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
}

.custom-select .items div:hover {
  background-color: #f7fafc;
}

.selectHide {
  display: none;
}
</style>
